var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"flash-message",class:{ 'flash-message__error': _vm.type === 'error', 'flash-message__success': _vm.type === 'success' },domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }